var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5771 22.3687H7.75309C4.31209 22.3687 2.00009 19.9537 2.00009 16.3597V8.04568C2.00009 4.45168 4.31209 2.03668 7.75309 2.03668H11.4921C11.9061 2.03668 12.2421 2.37268 12.2421 2.78668C12.2421 3.20068 11.9061 3.53668 11.4921 3.53668H7.75309C5.16909 3.53668 3.50009 5.30668 3.50009 8.04568V16.3597C3.50009 19.0987 5.16909 20.8687 7.75309 20.8687H16.5771C19.1611 20.8687 20.8311 19.0987 20.8311 16.3597V12.3317C20.8311 11.9177 21.1671 11.5817 21.5811 11.5817C21.9951 11.5817 22.3311 11.9177 22.3311 12.3317V16.3597C22.3311 19.9537 20.0181 22.3687 16.5771 22.3687Z",
    fill: "#9A9999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86768 15.4283H11.8447C12.2247 15.4283 12.5807 15.2813 12.8497 15.0123L20.3587 7.50331C20.6667 7.19531 20.8367 6.78531 20.8367 6.34931C20.8367 5.91231 20.6667 5.50131 20.3587 5.19331L19.1417 3.97631C18.5047 3.34131 17.4687 3.34131 16.8307 3.97631L9.35768 11.4493C9.09868 11.7083 8.95168 12.0523 8.94268 12.4173L8.86768 15.4283ZM11.8447 16.9283H8.09868C7.89668 16.9283 7.70268 16.8463 7.56168 16.7013C7.42068 16.5573 7.34368 16.3623 7.34868 16.1593L7.44268 12.3803C7.46168 11.6283 7.76468 10.9213 8.29668 10.3883H8.29768L15.7707 2.91531C16.9927 1.69531 18.9797 1.69531 20.2017 2.91531L21.4187 4.13231C22.0117 4.72431 22.3377 5.51131 22.3367 6.34931C22.3367 7.1873 22.0107 7.97331 21.4187 8.56431L13.9097 16.0733C13.3587 16.6243 12.6247 16.9283 11.8447 16.9283Z",
    fill: "#9A9999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.731 9.9166C19.539 9.9166 19.347 9.8436 19.201 9.6966L14.635 5.1306C14.342 4.8376 14.342 4.3626 14.635 4.0696C14.928 3.7766 15.402 3.7766 15.695 4.0696L20.261 8.6366C20.554 8.9296 20.554 9.4036 20.261 9.6966C20.115 9.8436 19.923 9.9166 19.731 9.9166Z",
    fill: "#9A9999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d8c6c0eef461a60b8d29b8a30bfdcfa9.svg";
export { ForwardRef as ReactComponent };